<template>
  <div id="totalBox">
    <div class="BModelIntro">
      <div class="introLeftBox">
        <div class="BModelIntroContent">
          <div class="BModelIntrotitle">管理端（B端）</div>
          <div class="BModelIntrotext">
                      任马停管理端（B端）是从客户端衍生出的一款适用于智能停车场管理的APP。
          </div>
        </div>
      </div>
      <div class="introRightBox">
        <img src="../../assets/product/Bintro1.png" class="BintroImg"/>
        <img src="../../assets/product/Bintro2.png" class="BintroImg"/>
        <img src="../../assets/product/Bintro3.png" class="BintroImg"/>
      </div>
    </div>
    <div class="BModelBusy">
      <div class="busyLeftBox">
        <div class="BModelBusyContent">
          <div class="busyImgBox">
            <img src="../../assets/product/busyImg.png" class="busyImgIcon"/>
          </div>
          <div class="busyTipBox">
            <img src="../../assets/product/busyicon.png" class="busyicon"/>
            <p class="busyTitle">应急处理</p>
            <div class="busyText">多种车位状况一目了然，直观管理</div>
            <div class="busyText">足不出户，轻松管理</div>
          </div>
        </div>
      </div>
      <div class="busyRightBox"></div>
    </div>
    <div class="callBox">
      <div class="callContent">
        <p class="callTitle">更多功能体验欢迎致电我们！</p>
        <p class="calltip">我们期待与您的合作</p>
        <img src="../../assets/product/callImg.png" class="callImg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CModel',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
}
.BModelIntro{
  height:580px;
  display: flex;
  align-items: center;
  margin-top: 36px;
}
.introLeftBox{
  width: calc(50% - 300px);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 29px;
}
.BModelIntroContent{
  width: 271px;
}
.BModelIntrotitle{
  font-size:28px;
  font-weight:400;
  color:rgba(0,0,0,1);
}
.BModelIntrotext{
  font-size:18px;
  line-height: 30px;
  font-weight:400;
  color:rgba(117,117,117,1);
  margin-top: 24px;
  text-align: left;
}
.introRightBox{
  width: calc(50% + 300px);
  height: 100%;
  background-color: RGBA(255, 182, 30, 1);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
}
.BintroImg{
  width: 250px;
  height: 422px;
}
.BModelBusy{
  height: 580px;
  display: flex;
  align-items: center;
}
.busyLeftBox{
  width: calc(50% + 300px);
  height: 100%;
  background:rgba(247,247,247,1);
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.busyRightBox{
  width: calc(50% - 300px);
  height: 100%;
}
.busyImgBox{
  width: 900px;
  height: 100%;
  background:rgba(247,247,247,0.6);
  background-image: url(../../assets/product/busyBack.png);
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.busyImgIcon{
  width: 655px;
}
.busyTipBox{
  width:480px;
  height:320px;
  padding: 46px 90px;
  background:rgba(255,255,255,1);
  box-shadow:0px 4px 20px 0px rgba(204,204,204,0.5);
  position: absolute;
  top: 130px;
  right: -300px;
}
.busyicon{
  width: 132px;
  height: 132px;
}
.busyTitle{
  font-size:22px;
  font-weight:400;
  color:rgba(255,110,30,1);
  margin-bottom: 19px;
}
.busyText{
  font-size:18px;
  font-weight:400;
  color:rgba(117,117,117,1);
}
.callBox{
  width: 100%;
  height: 700px;
  background:rgba(246,241,241,1);
}
.callContent{
  width: 1200px;
  height: 700px;
  margin: 0 auto;
  background-image: url(../../assets/product/callBack.png);
  background-repeat: no-repeat;
  background-color:rgba(246,241,241,1);
  padding-top: 92px;
}
.callTitle{
  font-size:50px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.calltip{
  font-size:30px;
  font-weight:400;
  color:rgba(80,80,80,1);
  margin-top: 24px;
}
.callImg{
  width: 812px;
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/BModel.vue